import React, {
  useContext, useEffect, useMemo, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useDataFetch } from '@common/hooks/dataFetch';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import SmartTable from '@common/components/smartTable';
import { useTranslation } from '@common/hooks/translation';
import Pagination from '@common/components/pagination';

import { PreferencesContext } from '@common/contexts/preferences';
import Loader from '@common/components/loader';
import {
  OTHER_ROWS, RESULT_PAGE_ITEM_COUNT, resultTableColumnConfigs, ROW_HEIGHT,
} from '../constants';
import _ from 'lodash';

const ResultTable = ({ filters, competitionsLoading, searchText }) => {
  const t = useTranslation();
  const [{ lang }] = useContext(PreferencesContext);
  const [data, isLoading] = useDataFetch(() => swarmRequest(filters, 'get_result_games'), [filters, lang]);
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = useRef(null);

  const parentHeight = document.querySelector('.results-page').clientHeight;

  const resultItemsCount = Math.floor((parentHeight) / ROW_HEIGHT) - OTHER_ROWS || RESULT_PAGE_ITEM_COUNT;

  useEffect(() => {
    if (searchText) setCurrentPage(1);
  }, [searchText]);

  const [pageData, pageCount] = useMemo(() => {
    if (!data?.games || _.isEmpty(data.games)) return [[], 0];

    const lowerSearchText = searchText.toLowerCase();

    const allList = searchText
      ? data.games.game.filter(
        (item) => item.team1_name.toLowerCase().includes(lowerSearchText)
            || item.team2_name.toLowerCase().includes(lowerSearchText),
      )
      : data.games.game;

    const listSorted = allList.sort((a, b) => b.date - a.date);

    const listSliced = listSorted.slice((currentPage - 1) * resultItemsCount, currentPage * resultItemsCount);

    return [listSliced, Math.ceil(listSorted.length / resultItemsCount)];
  }, [data, searchText, currentPage]);

  const sportId = pageData[0]?.sport_id;

  if (!data) return null;

  if (isLoading || competitionsLoading) return <Loader />;

  return (
    <div className="r-p-table-wrp" ref={tableRef}>
      <div className="r-p-table-inner">
        <div className="results-page-middle">
          <SmartTable
            hasPagination
            columnConfig={resultTableColumnConfigs(t, searchText, +sportId)}
            data={pageData}
            // enablePageSizeSelector
          />
        </div>
      </div>
    </div>
  );
};

ResultTable.propTypes = {
  filters: PropTypes.object.isRequired,
  searchText: PropTypes.string.isRequired,
};

export default ResultTable;
